import { createContext } from "react";

const AuthUserContext = createContext(null);

export default AuthUserContext;
